import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import { store } from "./store";
import vuetify from "./plugins/vuetify";
import "vuetify/dist/vuetify.min.css";
import "material-design-icons-iconfont/dist/material-design-icons.css";
import firebase from "firebase";
import VueTheMask from 'vue-the-mask';

firebase.initializeApp({
  apiKey: "AIzaSyCtuj_7HvrIDnfGw2Uu39NhfIbm1-rYKgQ",
  authDomain: "loto-jr.firebaseapp.com",
  databaseURL: "https://loto-jr.firebaseio.com",
  projectId: "loto-jr",
  storageBucket: "loto-jr.appspot.com",
  messagingSenderId: "430314365959",
  appId: "1:430314365959:web:8e6433bbcb04f237ffb6a2",
  measurementId: "G-PV3NLQ98W8",
});

firebase.auth().onAuthStateChanged((user) => {
  if (user) {
    store.dispatch("autoSignUserIn", user);
  }
});

Vue.config.productionTip = false;

Vue.use(VueTheMask)

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
